import { Field, InputType, ObjectType } from 'type-graphql'
import type { IAction } from '../../action'
import { ActionArgs } from '../../action'
import type { PaymentGatewayObject } from '../PaymentGatewayObject'
import type { PaymentGatewayProvider } from '../PaymentGatewayProviderEnum'

@InputType()
@ObjectType()
export class CreatePaymentCustomerArgs extends ActionArgs {
  @Field()
  email: string

  @Field()
  name: string

  @Field(() => String)
  gatewayProvider?: PaymentGatewayProvider
}

export interface ICreatePaymentCustomer extends IAction<PaymentGatewayObject, CreatePaymentCustomerArgs> {}
